import { useRef, useState } from "react";
import { useRecoilValue } from "recoil";

import type { LoanInterestRateUpdate } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";
import { useRequestInitialLoading } from "@/view_models/atoms";
import { SelectedProperty } from "@/view_models/propertySelectors";

import { loanError } from "../utils/loanError";

export const useSaveLoanInterestRate = () => {
  const selectedProperty = useRecoilValue(SelectedProperty);
  const requestInitialLoading = useRequestInitialLoading();
  const pending = useRef(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errorReason, setErrorReason] = useState<string>();
  const clearError = () => {
    setError("");
    setErrorReason(undefined);
  };

  const save = async (data: LoanInterestRateUpdate): Promise<boolean> => {
    if (pending.current) return false;
    pending.current = true;
    setLoading(true);
    clearError();
    try {
      await PropallyApiFactory().v1PropertiesPropertyIdLoanInterestRatesPatch(selectedProperty.id, data, {
        withCredentials: true,
      });
      requestInitialLoading();
      return true;
    } catch (e) {
      const failure = loanError(e);
      setError(failure.message);
      setErrorReason(failure.reason);
      return false;
    } finally {
      pending.current = false;
      setLoading(false);
    }
  };

  return { save, loading, error, errorReason, clearError };
};
